import React from 'react'
import Helmet from 'react-helmet'

const Title = ({ title }) => {
  var defaultTitle = '⚛️ app';
  return (
    <Helmet>
      <title>{title ? title : defaultTitle}</title>
    </Helmet>
  )
}
export default Title

// Title on the browser tab
